<template>
  <DocumentsScreen
    v-if="envelope && !isFetchingDocuments"
    :title="envelope.title"
    :documents="documents"
  />
</template>

<script setup>
// @ts-check
import { useRoute } from 'vue-router/composables';

import { useEnvelope, useEnvelopeDocuments } from '@/composables/envelopes';

import DocumentsScreen from '@/components/screens/envelopes/DocumentsScreen';

const route = useRoute();

const { envelope } = useEnvelope(route.params.fingerprint);
const { documents, isFetchingDocuments } = useEnvelopeDocuments(route.params.fingerprint);
</script>
